import React, { useEffect, useRef, useState } from "react";
import { RouteComponentProps } from "react-router-dom";
import { getModule, getModules } from "../../redux/reducers/ModuleReducer";
import { getModuleState } from "../../redux/reducers/ModuleStateReducer";
import { useTypedSelector } from "../../redux/reducers/RootReducer";
import { EModuleType } from "../../Model/EModuleType";
import Breadcrumb from "../Header/Breadcrumb";
import LayoutContent from "../LayoutContent";
import ImagerApi from "./../../api/ImagerApi";
import ImagerNavSubMenu from "./ImagerNavSubMenu";
import LightPathUtil from "../../Utility/LightPathUtil";
import Header from "../Header/Header";
import ImageGallery, { GalleryImgSrc } from "./ImageGallery";

type EfiProps = {
  imagerIdentifier: string;
  lightpath: string;
};

export default function Efi({ match }: RouteComponentProps<EfiProps>) {
  const imagerModules = useTypedSelector((state) =>
    getModules(state, EModuleType.IMAGER)
  );
  const imagerIdentifier =
    match.params.imagerIdentifier || imagerModules[0].identifier;
  const imagerModule = useTypedSelector((state) =>
    getModule(state, imagerIdentifier)
  );

  const moduleState = useTypedSelector((state) =>
    getModuleState(state, imagerIdentifier)
  );
  const imagerState = moduleState.imager;
  const lightpath = match.params.lightpath
    ? match.params.lightpath
    : imagerState
    ? imagerState.activeLightPath
    : "-1";

  const [efiImages, setEfiImages] = useState([] as GalleryImgSrc[]);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const efiImageRef = useRef<HTMLImageElement>(null);
  const imageContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    ImagerApi.getEfiImagePaths(imagerIdentifier)
      .then(async (imagePaths) => {
        let efiImages: GalleryImgSrc[] = [];
        for (const imagePath of imagePaths) {
          efiImages.push({
            name: imagePath,
            imageSrc: await ImagerApi.efiImage(imagerIdentifier, imagePath),
          });
        }
        setEfiImages(efiImages);
      })
      .catch((error) => {
        console.log(error.message);
      });
  }, [imagerIdentifier]);

  const onImageLoad = () => {
    if (efiImageRef.current != null && imageContainerRef.current != null) {
      const widthRatio =
        efiImageRef.current.naturalWidth / imageContainerRef.current.clientWidth;
      const heightRatio =
        efiImageRef.current.naturalHeight / imageContainerRef.current.clientHeight;
      const ratio = Math.max(widthRatio, heightRatio);

      efiImageRef.current.width = efiImageRef.current.naturalWidth / ratio;
      efiImageRef.current.height = efiImageRef.current.naturalHeight / ratio;
    }
  };

  const OnClickEfiItem = (i: number) => {
    setSelectedIndex(i);
  };

  const selectedEfiImage =
    efiImages.length > 1 ? (
      <img
        ref={efiImageRef}
        src={efiImages[selectedIndex].imageSrc}
        alt="Efi"
        onLoad={onImageLoad}
        // width={"100px"}
        // height={"100px"}
      />
    ) : null;

  return (
    <LayoutContent>
      <LayoutContent.Header>
        <Header>
          <Breadcrumb
            items={[
              {
                title: "EFI",
                to: "/imager/efi/" + imagerIdentifier + "/" + lightpath,
                disabled: false,
              },
            ]}
          />
          <Breadcrumb
            items={[
              {
                title: imagerModule.name,
                to: "/imager/efi/" + imagerIdentifier + "/" + lightpath,
                disabled: false,
              },
            ]}
          />
          <Breadcrumb
            items={[
              {
                title: LightPathUtil.toName(lightpath),
                to: "/imager/efi/" + imagerIdentifier + "/" + lightpath,
                disabled: false,
              },
            ]}
          />
        </Header>
      </LayoutContent.Header>

      <LayoutContent.SubMenu>
        <ImagerNavSubMenu imagerIdentifier={imagerIdentifier} />
      </LayoutContent.SubMenu>

      <LayoutContent.Content>
        <div
          ref={imageContainerRef}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
          }}
        >
         {selectedEfiImage}
        </div>
      </LayoutContent.Content>

      <LayoutContent.CommandPanel>
        <ImageGallery
          title={"Focus Level Slice"}
          items={efiImages}
          onClickItem={OnClickEfiItem}
          selectedIndex={selectedIndex}
        />
      </LayoutContent.CommandPanel>
    </LayoutContent>
  );
}
